import { actions } from './action'

const initialState = {
  ackDocuments: [],
  agentAckDocData: [],
  totalCount: null,
  agentStatusTotalCount: null,
  pagination: {
    skip: 0,
    limit: 10,
  },
  agentStatusPagination: {
    skip: 0,
    limit: 10,
  },
}
const onAcknowledgementState = (state = initialState, action) => {
  switch (action.type) {
    case actions.GET_ACKNOWLEDGEMENT_DOCUMENT:
      return {
        ...state,
        ackDocuments: action.payload.documentList,
        totalCount: action.payload.totalCount,
      }
    case actions.GET_AGENT_DOC_STATUS:
      return {
        ...state,
        agentAckDocData: action.payload?.documentList,
        agentStatusTotalCount: action.payload.totalCount,
      }
    case actions.HANDLE_PAGINATION:
      return {
        ...state,
        pagination: action.payload,
      }
    case actions.HANDLE_AGENT_DOC_VIEW_PAGINATION:
      return {
        ...state,
        agentStatusPagination: action.payload,
      }
    default:
      return state
  }
}
export default onAcknowledgementState
